/**
 * Entrada propia del panel, para cuando NO se abre desde GoHighLevel.
 *
 * Hasta ahora la unica via de sesion era el iframe de una Custom Page de GHL:
 * abrir apptoolkit.fluxo.consulting en el navegador o en el movil daba "No
 * session source available". Esta pantalla pide la contrasena del operador, la
 * cambia por una sesion en el servidor y deja el panel abierto igual que dentro
 * de GHL. La contrasena no se guarda en ningun sitio del navegador: se manda una
 * vez y lo que queda es la sesion.
 */
import { useState } from 'react';
import { entrarComoOperador, type SessionState } from '../lib/session.js';

export function EntradaOperador({ onEntra }: { onEntra: (s: SessionState) => void }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [entrando, setEntrando] = useState(false);

  const entrar = async (): Promise<void> => {
    if (!password || entrando) return;
    setEntrando(true);
    setError(null);
    try {
      onEntra(await entrarComoOperador(password));
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
      setPassword('');
    } finally {
      setEntrando(false);
    }
  };

  return (
    <main className="op-login-page">
      <section className="op-login-card" aria-label="Acceso al studio de Fluxo">
        <aside className="op-login-rail">
          <div className="op-login-brand" aria-label="Fluxo studio">flu<span className="op-x" aria-hidden="true">x</span>o<span> / studio</span></div>
          <div className="op-login-intro">
            <span className="op-login-eyebrow">Panel de operaciones</span>
            <h2>Todo preparado.<br /> Paso a paso.</h2>
            <p>Clientes, productos y altas en un mismo lugar.</p>
          </div>
          <div className="op-login-route" aria-hidden="true"><span>01 <strong>Preparar</strong></span><span>02 <strong>Configurar</strong></span><span>03 <strong>Cerrar</strong></span></div>
        </aside>
        <form className="op-login-form" onSubmit={(e) => { e.preventDefault(); void entrar(); }} aria-busy={entrando}>
          <span className="op-login-eyebrow">Acceso de operador</span>
          <h1>Entra en tu studio.</h1>
          <p className="op-login-description">Panel de operaciones. Entra con tu contraseña.</p>
          <label htmlFor="op-password">Contraseña</label>
          <input
            id="op-password"
            type="password"
            autoComplete="current-password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={entrando}
            aria-invalid={Boolean(error)}
            aria-describedby={error ? 'op-login-error' : undefined}
          />
          {error && <div id="op-login-error" className="op-login-error" role="alert">{error}</div>}
          <button type="submit" className="op-login-submit" disabled={!password || entrando}>
            {entrando ? 'Entrando…' : 'Entrar'}
          </button>
          <p className="op-login-note">Si abres el panel desde dentro de GoHighLevel no hace falta: la sesión la da GHL.</p>
        </form>
      </section>
    </main>
  );
}
